const awsResources = {
    "dev-sqs-scheduleUpdateEndpoint": "https://sqs.us-east-1.amazonaws.com/239811121152/arg-schedeule-update-dev",
    "dev-cognito-adminRoleArn": "arn:aws:iam::239811121152:role/moore-arg-user-admin",
    "dev-userPoolId": "us-east-1_VKndxxrH6",
    "clientId": "1enimgplmomcvlmub08mlg2kkt"
};


export default awsResources;
